function filtersToSearchParams(filters, offset, limit) {
	const url = new URL(window.location.href);

	if (filters && Object.keys(filters).length) {
		Object.entries(filters).forEach(([key, value]) => {
			if (String(value)) {
				url.searchParams.set(key, String(value));
			}
		});
	}

	if (offset)
		url.searchParams.set('offset', String(offset));
	if (limit)
		url.searchParams.set('limit', String(limit));

	return url.search;
}

export default filtersToSearchParams;

